<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" by-operator :loading="loading"/>

    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('operatorJourneysCountReport.title') }}</h2>
      <p class="text-center mb-3 no-print">
        {{ $t('operatorJourneysCountReport.description') }}
      </p>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && !error && reportEnvelope" class="row">
      <div class="col-6">
        <card :title="$t('operatorJourneysCountReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorJourneysCountReport.summary.operator') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.operatorName }} ({{ reportEnvelope.operatorId }})</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorJourneysCountReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.generatedAt | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorJourneysCountReport.summary.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.periodFrom | dateOnly }} - {{
                  reportEnvelope.periodTo | dateOnly
                }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorJourneysCountReport.summary.totalJourneysCount') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.totalJourneysCount }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>


    <div v-if="loading === false && !error && reportData" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`operatorJourneysCountReport.tableTitle`) }}<small v-if="reportEnvelope"
            class="ml-2 text-muted">({{ reportEnvelope.periodFrom | dateOnly }} - {{ reportEnvelope.periodTo | dateOnly }})</small>
          </h4>
          <div>
            <el-table :data="reportData"
                      :empty-text="$t('generic.emptyReportForThePeriod')"
                      show-summary
                      :summary-method="getJourneysCountTableTotal">
              <el-table-column :label="$t('operatorJourneysCountReport.table.day')">
                <template slot-scope="{ row }">{{ row.day | dateOnly }}</template>
              </el-table-column>
              <el-table-column :label="$t('operatorJourneysCountReport.table.count')">
                <template slot-scope="{ row }">{{ row.count }}</template>
              </el-table-column>
            </el-table>
          </div>

        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert} from 'src/components';
import {mapActions, mapState} from "vuex";
import DetailedReportPeriod from 'src/components/DetailedReportPeriod/DetailedReportPeriod';
import ReportFilter from "./ReportFilter";

export default {
  name: 'OperatorJourneysCountReport',
  components: {
    BaseAlert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    DetailedReportPeriod,
    ReportFilter
  },
  data() {
    return {
      report: null, // Received report data.
      reportEnvelope: null,
      reportData: [],

      // data: [],
      // totalJourneysCount: 0,
      // periodFrom: null,
      // periodTo: null,
      // generatedAt: null,
      // operatorId: '',
      // operatorName: '',
    };
  },
  computed: {
    ...mapState({
      loading: state => state.operator_journeys_count_report.loading,
      error: state => state.operator_journeys_count_report.error,
      data: state => state.operator_journeys_count_report.data,
    }),
  },
  methods: {
    ...mapActions(['LoadOperatorJourneysCountReport']),
    reloadReport(query) {
      this.LoadOperatorJourneysCountReport(query);
    },
    getJourneysCountTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('operatorJourneysCountReport.table.summaryRow');
          return;
        }
        if (index === 1) {
          let values;
          values = data.map(item => Number(item.count));

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    prepareReportData(report) {
      if (!report) {
        this.reportData = null;
        this.reportEnvelope = null;
        return
      }

      this.reportEnvelope = {
        totalJourneysCount: 0,
        periodFrom: report.from,
        periodTo: report.to,
        generatedAt: report.generated_at,
        operatorId: report.operatorId,
        operatorName: report.operatorName,
      },

        this.reportData = report.data

      this.reportEnvelope.totalJourneysCount = this.reportData.reduce((r, d) => r + d.count, 0);
    }
  },
  mounted() {
    this.prepareReportData(this.data)
  },
  watch: {
    data(data) {
      this.prepareReportData(data)
    }
  }
};
</script>

